import React from 'react';
import './ProfileStats.css';

const ProfileStats = () => {
  return (
    <div className="stats">
      <div className="flex flex-fd-c flex-ai-c stats__item">
        <p className="stats__count">1200</p>
        <p>Haes</p>
      </div>
      <div className="flex flex-fd-c flex-ai-c stats__item">
        <p className="stats__count">450</p>
        <p>Peers</p>
      </div>
      <div className="flex flex-fd-c flex-ai-c stats__item">
        <p className="stats__count">200</p>
        <p>Followers</p>
      </div>
    </div>
  );
};

export default ProfileStats;
